/**
 * Input Schema of OcorrenciaTrackingResponsavel
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {OcorrenciaTrackingResponsavel} from '@/model/resource/OcorrenciaTrackingResponsavel'

/* TODO: review generated schema */
export class InputOcorrenciaTrackingResponsavelSchema extends Schema {
  readonly name = 'InputOcorrenciaTrackingResponsavel'

  readonly fieldSet: FieldSet<OcorrenciaTrackingResponsavel> = {
    cnpj: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'cnpj',
        maxlength: 21,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    idOcorrenciaExterna: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'number',
        maxlength: 11,
        step: 1,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    descricao: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'textarea',
        maxlength: 500,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required|max:500',
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
  }
}
